import { overviewTour } from "./overviewTour"
import { toursCanBeResetTour } from "./toursCanBeResetTour"
import { combinationExplorerTour } from "./combinationExplorerTour"
import { rewardsTour } from "./rewardsTour"
import { projectSettingsTour } from "./projectSettingsTour"
import { variableExplorerTour } from "./variableExplorerTour"
import { basicVariableTour } from "./basicVariableTour"
import { visualVariableTour } from "./visualVariableTour"

// Only export tours that should be shown in tour settings
export const tours = [overviewTour, combinationExplorerTour, rewardsTour, projectSettingsTour, variableExplorerTour, basicVariableTour, visualVariableTour]

// Export tours that should not appear in tour settings
export { toursCanBeResetTour }

/**
 * Format a tour ID into a human-readable name
 * @param tourId - The ID of the tour
 * @returns A formatted name for the tour
 */
export function formatTourName(tourId: string): string {
   // Look for the tour in our registry
   const tour = tours.find((t) => t.id === tourId)
   if (tour) {
      return tour.humanReadableName
   }

   // Format unknown tour IDs to be readable
   return tourId
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ")
}
